import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressTracker = ({ currentLesson, totalLessons, completedLessons, progressPercentage }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6 shadow-elevation-1">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-success/10 rounded-full flex items-center justify-center">
            <Icon name="TrendingUp" size={20} className="text-success" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">Learning Progress</h3>
            <p className="text-sm text-muted-foreground">
              {completedLessons?.length} of {totalLessons} lessons completed
            </p>
          </div>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold text-primary">{progressPercentage}%</div>
          <p className="text-xs text-muted-foreground">Complete</p>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="w-full h-3 bg-muted rounded-full overflow-hidden mb-4">
        <div
          className="h-full bg-gradient-to-r from-primary to-success rounded-full transition-all duration-500"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>

      {/* Lesson Indicators */}
      <div className="flex items-center gap-2 flex-wrap">
        {Array?.from({ length: totalLessons })?.map((_, index) => {
          const isCompleted = completedLessons?.includes(index);
          const isCurrent = currentLesson === index;

          return (
            <div
              key={index}
              className={`flex items-center justify-center w-8 h-8 rounded-full text-xs font-semibold transition-all ${
                isCompleted
                  ? 'bg-success text-success-foreground'
                  : isCurrent
                  ? 'bg-primary text-primary-foreground ring-2 ring-primary ring-offset-2'
                  : 'bg-muted text-muted-foreground'
              }`}
              title={`Lesson ${index + 1}`}
            >
              {isCompleted ? (
                <Icon name="Check" size={14} />
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressTracker;